import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const HASH_LINKS = [
    { hash: "problem", label: "Problem" },
    { hash: "solution", label: "Platform" },
    { hash: "how", label: "How it works" },
    { hash: "trust", label: "Security" },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    // When arriving at "/" with a #hash, scroll into view after mount
    useEffect(() => {
        if (location.pathname === "/" && location.hash) {
            const id = location.hash.replace("#", "");
            setTimeout(() => {
                const el = document.getElementById(id);
                if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 80);
        }
    }, [location]);

    const handleHash = (e, hash) => {
        e.preventDefault();
        if (location.pathname === "/") {
            const el = document.getElementById(hash);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
            navigate(`/#${hash}`);
        }
    };

    const handleCta = (e) => {
        e.preventDefault();
        if (location.pathname === "/") {
            const el = document.getElementById("footer-cta");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
            navigate("/#footer-cta");
        }
    };

    return (
        <header
            data-testid="site-nav"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "backdrop-blur-xl bg-black/60 border-b border-white/5"
                    : "bg-transparent"
            }`}
        >
            <div className="mx-auto max-w-7xl px-6 lg:px-10 h-16 flex items-center justify-between">
                <Link
                    to="/"
                    className="flex items-center gap-2.5 group"
                    data-testid="nav-logo"
                >
                    <span
                        aria-hidden="true"
                        className="flex h-8 w-8 items-center justify-center rounded-xl border border-[#10B981]/30 bg-[#10B981]/10 text-[13px] font-semibold text-[#34D399]"
                    >
                        D
                    </span>
                    <span className="font-display text-[17px] font-semibold tracking-tight">
                        Dendros
                        <span className="text-[#10B981]">.ai</span>
                    </span>
                </Link>

                <nav className="hidden md:flex items-center gap-8 text-[13px] text-neutral-400">
                    {HASH_LINKS.map((l) => (
                        <a
                            key={l.hash}
                            href={`/#${l.hash}`}
                            onClick={(e) => handleHash(e, l.hash)}
                            className="hover:text-white transition-colors"
                            data-testid={`nav-${l.hash}`}
                        >
                            {l.label}
                        </a>
                    ))}
                    <NavLink
                        to="/pulse"
                        end
                        className={({ isActive }) =>
                            `transition-colors ${isActive ? "text-[#10B981]" : "hover:text-white"}`
                        }
                        data-testid="nav-pulse"
                    >
                        Demo
                    </NavLink>
                </nav>

                <button
                    data-testid="nav-cta-button"
                    onClick={handleCta}
                    className="group inline-flex items-center gap-2 rounded-full bg-[#10B981] hover:bg-[#34D399] px-4 py-2 text-[13px] font-medium text-black transition-all"
                >
                    Secure Early Access
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        className="transition-transform group-hover:translate-x-0.5"
                    >
                        <path
                            d="M3 7h8m0 0L7 3m4 4l-4 4"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
            </div>
        </header>
    );
}
